// @ts-nocheck
import React from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from 'react-i18next';

function AutomationBranchingForm({
  automation,
  onAutomationChange,
  processTypes = {},
  error,
  classes,
  disabled = false,
}) {
  const { t } = useTranslation();
  const processTypeOptions = Array.isArray(processTypes)
    ? processTypes
    : Object.values(processTypes || {});

  const updateOption = (index, patch) => {
    const nextOptions = automation.branchingOptions.map((option, optionIndex) =>
      optionIndex === index ? { ...option, ...patch } : option,
    );

    onAutomationChange({
      ...automation,
      branchingOptions: nextOptions,
    });
  };

  const addOption = () => {
    onAutomationChange({
      ...automation,
      branchingOptions: [
        ...(automation.branchingOptions || []),
        { label: '', nextProcessTypeId: null },
      ],
    });
  };

  const removeOption = (index) => {
    onAutomationChange({
      ...automation,
      branchingOptions: automation.branchingOptions.filter(
        (_, optionIndex) => optionIndex !== index,
      ),
    });
  };

  const handleToggle = (_, checked) => {
    onAutomationChange({
      ...automation,
      branchingEnabled: checked,
      nextProcessTypeId: checked ? null : automation.nextProcessTypeId,
      branchingQuestion: checked ? automation.branchingQuestion : '',
      branchingOptions: checked
        ? automation.branchingOptions
        : [
            { label: '', nextProcessTypeId: null },
            { label: '', nextProcessTypeId: null },
          ],
    });
  };

  return (
    <>
      <FormControlLabel
        classes={{ root: classes.switchContainer, label: classes.switchLabel }}
        labelPlacement="start"
        control={
          <Switch
            checked={!!automation.branchingEnabled}
            onChange={handleToggle}
            name="branchingEnabled"
            disabled={disabled}
          />
        }
        label={t('Habilitar bifurcación en este proceso')}
      />

      {disabled && (
        <Typography variant="caption" color="textSecondary">
          {t('Primero debes activar la creación del proceso de salida para usar bifurcación.')}
        </Typography>
      )}

      {!disabled && automation.branchingEnabled && (
        <Grid container classes={{ root: classes.formGrid }} spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t('Pregunta operacional')}
              value={automation.branchingQuestion || ''}
              onChange={(event) =>
                onAutomationChange({
                  ...automation,
                  branchingQuestion: event.target.value,
                })
              }
              error={!!error?.prompt}
              helperText={error?.prompt || t('Ejemplo: ¿Resultado de inspección?')}
            />
          </Grid>

          {!!error?.optionsGeneral && (
            <Grid item xs={12}>
              <Typography variant="caption" color="error">
                {error.optionsGeneral}
              </Typography>
            </Grid>
          )}

          {(automation.branchingOptions || []).map((option, index) => (
            <Grid item xs={12} key={`branch-option-${index}`}>
              <Box border={1} borderColor="#E0E0E0" borderRadius={8} p={2}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      label={t('Respuesta {{number}}', { number: index + 1 })}
                      value={option.label || ''}
                      onChange={(event) =>
                        updateOption(index, { label: event.target.value })
                      }
                      error={!!error?.options?.[index]?.label}
                      helperText={error?.options?.[index]?.label || ''}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={processTypeOptions}
                      getOptionLabel={(item) => item?.name || ''}
                      noOptionsText={t('No hay tipos de proceso disponibles')}
                      value={
                        processTypeOptions.find(
                          (item) => item.id === option.nextProcessTypeId,
                        ) || null
                      }
                      onChange={(_, value) =>
                        updateOption(index, {
                          nextProcessTypeId: value?.id || null,
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t('Proceso siguiente')}
                          error={!!error?.options?.[index]?.nextProcessTypeId}
                          helperText={
                            error?.options?.[index]?.nextProcessTypeId || ''
                          }
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={1}>
                    <IconButton
                      onClick={() => removeOption(index)}
                      disabled={(automation.branchingOptions || []).length <= 2}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button
              startIcon={<AddIcon />}
              onClick={addOption}
              color="primary"
            >
              {t('Agregar respuesta')}
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="caption" color="textSecondary">
              {t(
                'Cada respuesta define a qué proceso siguiente debe avanzar el lote.',
              )}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default AutomationBranchingForm;
